// Routes
export const HOME = '/';
export const MEMORIES = 'memories';
export const CONTACT =  'contact';
